const resolveSquadEnforcedMode = isEnabled => {
    if (isEnabled === 'true') {
        return {
            status: 'known',
            value: 'enforced',
        }
    }
    if (isEnabled === 'false') {
        return {
            status: 'known',
            value: 'disabled',
        }
    }
    return {
        status: 'unknown',
        value: 'null',
    }
}


export { resolveSquadEnforcedMode }
